var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_1563_814)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5935 24.75H49.7185C49.3289 24.75 48.9554 24.9047 48.6799 25.1802C48.4045 25.4556 48.2497 25.8292 48.2497 26.2188C48.2497 26.6083 48.4045 26.9819 48.6799 27.2573C48.9554 27.5328 49.3289 27.6875 49.7185 27.6875H52.0538L42.3747 37.3666L33.1363 28.1134C32.9997 27.9758 32.8373 27.8665 32.6583 27.7919C32.4793 27.7174 32.2874 27.679 32.0935 27.679C31.8996 27.679 31.7076 27.7174 31.5286 27.7919C31.3496 27.8665 31.1872 27.9758 31.0507 28.1134L16.3632 42.8009C16.2255 42.9375 16.1162 43.0999 16.0417 43.2789C15.9671 43.4579 15.9287 43.6499 15.9287 43.8438C15.9287 44.0376 15.9671 44.2296 16.0417 44.4086C16.1162 44.5876 16.2255 44.75 16.3632 44.8866C16.4997 45.0242 16.6621 45.1335 16.8411 45.2081C17.0201 45.2826 17.2121 45.321 17.406 45.321C17.5999 45.321 17.7918 45.2826 17.9708 45.2081C18.1498 45.1335 18.3123 45.0242 18.4488 44.8866L32.0935 31.2272L41.3319 40.4803C41.4685 40.618 41.6309 40.7272 41.8099 40.8018C41.9889 40.8764 42.1808 40.9148 42.3747 40.9148C42.5686 40.9148 42.7606 40.8764 42.9396 40.8018C43.1186 40.7272 43.281 40.618 43.4175 40.4803L54.1247 29.7584V32.0938C54.1247 32.4833 54.2795 32.8569 54.5549 33.1323C54.8304 33.4078 55.2039 33.5625 55.5935 33.5625C55.983 33.5625 56.3566 33.4078 56.632 33.1323C56.9075 32.8569 57.0622 32.4833 57.0622 32.0938V26.2188C57.0622 25.8292 56.9075 25.4556 56.632 25.1802C56.3566 24.9047 55.983 24.75 55.5935 24.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3438 47.1044V52.6563C20.3438 53.0458 20.4985 53.4194 20.7739 53.6949C21.0494 53.9703 21.423 54.125 21.8125 54.125H27.6875C28.077 54.125 28.4506 53.9703 28.7261 53.6949C29.0015 53.4194 29.1562 53.0458 29.1562 52.6563V38.3213L20.52 46.9575L20.3438 47.1044Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8438 43.5794V52.6563C43.8438 53.0458 43.9985 53.4194 44.2739 53.6949C44.5494 53.9703 44.923 54.125 45.3125 54.125H51.1875C51.577 54.125 51.9506 53.9703 52.2261 53.6949C52.5015 53.4194 52.6562 53.0458 52.6562 52.6563V35.3838L45.4888 42.5513C45.0236 43.0119 44.4617 43.3632 43.8438 43.5794Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0938 35.3838V52.6563C32.0938 53.0458 32.2485 53.4194 32.5239 53.6949C32.7994 53.9703 33.173 54.125 33.5625 54.125H39.4375C39.827 54.125 40.2006 53.9703 40.4761 53.6949C40.7515 53.4194 40.9062 53.0458 40.9062 52.6563V43.5794C40.2883 43.3632 39.7264 43.0119 39.2612 42.5513L32.0938 35.3838Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1563_814",
    x1: 3,
    y1: -0.00000259137,
    x2: 69,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.a5660f44274785969b6a214aa85378cc.svg";
export { ForwardRef as ReactComponent };